export default "__VITE_ASSET__Bf6U6u8P__"